import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { Badge } from '../badge/badge'

import style from './counter-icon.module.css'

const propTypes = {
    badgeClassName: PropTypes.string,
    className: PropTypes.string,
    iconCount: PropTypes.number
}

const defaultProps = {
    iconCount: 0
}

const getCounterString = count => {
    if (!Number.isInteger(count) || count === 0) {
        return ''
    }
    return count > 99 ? '99+' : count + ''
}

const CounterIcon = props => {
    const { badgeClassName, children, className, iconCount } = props
    const combinedClassName = cx(style['icon'], className)
    const combinedBadgeClassName = cx(style['counter'], badgeClassName)
    return (
        <div className={combinedClassName}>
            {children}
            <Badge className={combinedBadgeClassName}>{getCounterString(iconCount)}</Badge>
        </div>
    )
}

CounterIcon.propTypes = propTypes
CounterIcon.defaultProps = defaultProps

export { CounterIcon }
